import { MDTApi } from './mdtapi.js';

export const fetchAddressFormatConfiguration = async (territoryId) => {
    const data = {
        territoryId,
    };

    return await MDTApi.call('api.configurations.addressFormats', {
        method: 'GET',
        params: data,
        errorCallback: () => {}, // Don't show a blocking modal
    });
};
